import { mapCollection } from '../../utils/collection.utils';
import { NewAndUpdatedSchedulerTaskManufacturingOrder } from '../new-and-updated-scheduler-task-manufacturing-order';
import { SchedulerTaskManufacturingOrderBuilder } from './scheduler-task-manufacturing-order.builder';

export class NewAndUpdatedSchedulerTaskManufacturingOrderBuilder {

  static fromJson(json) {
    return (json)
      ? new NewAndUpdatedSchedulerTaskManufacturingOrder(
          SchedulerTaskManufacturingOrderBuilder.fromList(json.newSchedulerTasksWithManufacturingOrders),
          SchedulerTaskManufacturingOrderBuilder.fromList(json.reSchedulerTasksWithManufacturingOrders),
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(NewAndUpdatedSchedulerTaskManufacturingOrderBuilder.fromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/new-and-updated-scheduler-task-manufacturing-order.builder.ts